export const productImages = {
    breakers: [
        "1POLE BREAKER.jfif",
        "2POLE BREAKER.jfif",
        "ABB CONTACTOR.png",
        "ABB CONTACTORS.png",
        "ALFANAR BREAKERS.jpg",
        "breaker box.png",
        "breaker panel board accessories.jpg",
        "BREAKERS 1, 2 & 3 POLE.png",
        "CHINT CONTACTOR.png",
        "CONTACTOR.png",
        "CONTACTORS.jpg",
        "EATON 2P.jfif",
        "GE BREAKER .jpg",
        "MCCB_s.jpg",
        "Panel boards.png",
        "Push buttons.jpg",
        "schneider breaker .jfif",
        "SCHNEIDER CONTACTOR.png",
        "SCHNEIDER PRODUCTS.png",
        "SQUARE-D breaker.jfif",
        "SQUARE-D SAFETY SWITCH.jfif",
        "timer.jpg",
        "TYPES OF BREAKERS.jpg"
    ]
    ,
    switches: [
        "13a single and double socket with switch.jpg",
        "3 way switch.png",
        "32A switch .jpg",
        "4 way switch.jpg",
        "Ameican type switches.jpg",
        "American type socket.jpg",
        "Bell switch.jpg",
        "Double outlet box.jpg",
        "Double outlet steel box .jpg",
        "double socket with USB.jfif",
        "Double socket.jpg",
        "double switch.jpg",
        "Dual adaptor.jfif",
        "Extention box.png",
        "Extention cord.jfif",
        "extention.jfif",
        "Fan regulator.jpg",
        "Floor box.jpg",
        "floor socket.jpg",
        "Industrial Plug & socket.png",
        "Light Dimmer.jpeg",
        "Multi adaptor.jpg",
        "outlet box .jpg",
        "outlet with 2 USB.jfif",
        "photocell.jpg",
        "Plug.jfif",
        "RCD socket.jpg",
        "Single 13A socket with USB A & C.jpg",
        "Single 13a socket.jpg",
        "single switch.png",
        "Steel box.jpg",
        "Steel outlet box.jpg",
        "Universal-Travel-Adapter.png",
        "wall mounted photocell.jpg",
        "wall outlet cover.jfif",
        "waterproof outlet box.jfif",
        "waterproof-switch-socket.jpg",
        "weatherproof boutlet box.jfif"
    ]
    ,
    cables: [
        "aluminum-lugs-for-cable.jpg",
        "Cable clips.jpg",
        "cable drum 50mtr.jpg",
        "Cable lug .jpg",
        "cable lugs.jpg",
        "Cable puller.jpg",
        "cable tie.jpg",
        "cables.txt",
        "flat-cable.jpg",
        "Floor trunking.png",
        "Gl Hose.webp",
        "heat shrink tube .jpg",
        "heat shrink tube big.webp",
        "Hose.png",
        "Orange hose.jpg",
        "Power cable.png",
        "pvc insulated cable.jpg",
        "PVC insulated wires.webp",
        "Rj45 cable.jpg",
        "sloted trunking.jpg",
        "speaker-cable.jpg",
        "Steel cable tie.jpg",
        "Steel flexible hose.jpg",
        "Steel hose.jpg",
        "Telephone cable.jpg",
        "Trunking with adhesive.jpg",
        "Trunking.jpg",
        "Wire hose.jpg",
        "wire marker.jpg",
        "wires.png"
    ]
    ,
    accessories: [
        "Analog Meter.jfif",
        "Cable accessories.jfif",
        "Cable TIe clip.jpg",
        "Clamp Meter.jpg",
        "Colored cable tie.jpg",
        "Doorbell.jpg",
        "Electric meter.jpeg",
        "Electrical tape.jfif",
        "Emt Products.jpg",
        "Float-switch.jpg",
        "Glass Fuse.jfif",
        "Measuring tape.jpeg",
        "Outdoor Led mount stand.jfif",
        "Outlet PVC Cover.jfif",
        "Silicone.jpg",
        "Stabilizer.jpg",
        "Super glue.jpeg",
        "Tapes.jpeg",
        "Tester.jpg",
        "Transformer.png",
        "Warning tape.jpeg",
        "Wire nut connector.jfif"
    ]
    ,
    fans: [
        "Air curtains.jpg",
        "ceiling exhaust fan.jfif",
        "Ceiling fan.jpg",
        "Industrail wall mount fan.jpg",
        "Industrial stand fan.jpg",
        "Mist fan.jpg",
        "Portable exhaust fan.jpg",
        "Rechargable fan.jpg",
        "Roof Mount Exhaust fan.jpg",
        "round exhaust fan.png",
        "Stand fan.jfif",
        "Steel exhaust fan.jpg",
        "Table fan.jpg",
        "Wall exhaust fan.jfif",
        "Wall fan.jpg"
    ]
    ,
    explosionProof: [
        "Cable gland brass double compression.png",
        "Detectable tape.png",
        "ECD15 DRAIN BREATHER.jpeg",
        "ECD18 DRAIN BREATHER.jpeg",
        "Explosion proof 20A.png",
        "Explosion proof beacon 151xst.jpeg",
        "Explosion proof Beacon XB15 MEDC.png",
        "Explosion proof Beacon.jpg",
        "Explosion proof Break glass.png",
        "Explosion proof cable gland brass barrier type.png",
        "Explosion proof cable gland brass.png",
        "Explosion proof cable gland single compression.png",
        "Explosion proof ceiling mount led.jpg",
        "Explosion proof Circuit Breaker.png",
        "Explosion proof combination unit sounder beacon.png",
        "Explosion proof conduit body fitting GUA series.jpg",
        "Explosion proof Conduit body fitting.png",
        "Explosion proof conduit body fittings PVC coated.png",
        "Explosion proof drain breather.png",
        "Explosion proof enclosure aluminium CL1 DIV1.png",
        "Explosion proof Enclosure Fiberglass.png",
        "Explosion proof enclosure ss.png",
        "Explosion proof Exit light.png",
        "Explosion proof expansion joint eaton.webp",
        "Explosion proof EYD fitting.jpg",
        "Explosion proof fire alarm pull type.jpg",
        "Explosion proof fire push button.png",
        "Explosion proof flood light FMVSY series.jpg",
        "Explosion proof GFCI.png",
        "Explosion proof Hand lamp.png",
        "Explosion proof High bay light vmvl series.jpg",
        "Explosion proof high bay pole mount.jpg",
        "Explosion proof Led FLood Light .jpg",
        "Explosion proof light pendant mount.jfif",
        "Explosion proof light VMVS SERIES.jpg",
        "Explosion proof light VMVS-VMVM SERIES.jpg",
        "Explosion proof linear CL1 DIV2.jpg",
        "Explosion proof Linear led emergency type.jpg",
        "Explosion proof Linear led light CL1 DIV 2.jpg",
        "Explosion proof linear light CL1 DIV1.jpg",
        "Explosion proof linear light CLV1 DIV2 emergency type.jpg",
        "Explosion proof linear light CLV1 DIV2.jpg",
        "Explosion proof panel board CV1 DIV1.png",
        "Explosion proof panel board switch.png",
        "Explosion proof plug brass.png",
        "Explosion proof Plug fibre glass.png",
        "Explosion proof plug.webp",
        "Explosion proof plugs.png",
        "Explosion proof Push button indicator.png",
        "Explosion proof Receptacle 20A.png",
        "Explosion proof receptacle 30-400AMP.webp",
        "Explosion proof receptacle.jpg",
        "Explosion proof Rigid Coupling.webp",
        "Explosion proof safety switch CL1 DIV1.png",
        "Explosion proof safety switch ss.jpg",
        "Explosion proof skid system.png",
        "Explosion proof sounder & beacon combination unit.png",
        "Explosion proof sounder DB1 MEDC.png",
        "Explosion proof sounder DB3B MEDC.png",
        "Explosion proof SS cable gland.png",
        "Explosion proof Switch 20A.png",
        "Explosion proof switched receptacle.jpg",
        "Explosion proof Telephone CL1 DIV1.jpg",
        "Explosion proof telephone.jpg",
        "RGS PVC coated fittings.jpeg",
        "Rigid conduit.webp",
        "Rigid elbow.webp"
    ]
    ,
    led: [
        "Al raed flood light.png",
        "Battern light.jfif",
        "Bulb efficiency.jfif",
        "Cob light.png",
        "Drum light.jpg",
        "Emergency light.jpg",
        "Exit light.png",
        "Flood light.png",
        "Floor light.jpg",
        "Garden Light.jfif",
        "Globe light.jpg",
        "High-bay light.jfif",
        "Holder.png",
        "Led ballast.jfif",
        "Led Capsule.jfif",
        "Led color code.jfif",
        "Led driver.jfif",
        "Led Panel 60x60.jfif",
        "Led tube fixture.png",
        "Led tube light.jfif",
        "Motion sensor lights.jfif",
        "Multi Colored strip light.jpg",
        "Outdoor Light with stand.jpg",
        "Outdoor wall light.png",
        "Panel light ceiling mount.jfif",
        "Panel light.jfif",
        "Remote Bulb.jfif",
        "Smart bulb.jfif",
        "Solar Flood light.jfif",
        "Solar Street light.jfif",
        "Spot light .png",
        "Square panel light.jfif",
        "Street Light.jfif",
        "Strip light 5m.png",
        "Track light.jpg",
        "UFO type high bay Light.jfif"
    ]
    ,
    nonLed: [
        "all bulb charts.jpg",
        "Ballast.jpeg",
        "bulbsize.jpg",
        "Capacitor.png",
        "Capsule 2 pin.jpg",
        "Capsule 4pin.jpg",
        "Capsule 5 pin.jpg",
        "Capsule lamp.jpg",
        "Flood light Fixture.jpeg",
        "Fluorescent Tube.png",
        "Halogen fixture.jpg",
        "Halogen spot light MR16.jpg",
        "HALOGEN STUDIO LAMP.jpg",
        "High bay lamp Fixture.jpeg",
        "Holder base.jpg",
        "holder.jpg",
        "HPS lamp.png",
        "Ignitor.jpeg",
        "Lamp Ignitor.jpeg",
        "Light bulb.jpg",
        "Metal Halide lamp.jpg",
        "Par light.jpg",
        "Round Tube.jpg",
        "Starter.jfif",
        "Tube Fixture grille type.jpeg",
        "Tube Fixture waterproof.jpeg",
        "Tube Fixture.jpeg",
        "Tungstun double-end.jpg",
        "U-Tube.jpeg",
        "UV tube.jpeg"
    ]
    ,
    hardware: [
        "Adjustable wrench .jpeg",
        "Adjustable Wrench.jpeg",
        "Allen key wrench.jpg",
        "b248526d-8fbf-42c7-8348-dfefd74c9477 (1).jpeg",
        "b4ff7c42-aeb2-4fbd-a4b6-2e1a690109b4.jpeg",
        "Bolt & Nuts.jpg",
        "Cordless-drill.jpg",
        "Digital multi-meter.jpg",
        "Drill bit set.jpg",
        "Drill bits.jpg",
        "Drill Machine.jpg",
        "Hammer.jpg",
        "Knife cutter.jpeg",
        "knife-cutter.jpg",
        "L-shape ruler.jpeg",
        "Magnetic level torpedo.jpeg",
        "Pliers.jpg",
        "Saw Blade.jpg",
        "Saw machine.jpg",
        "Scissor .jpg",
        "Screw.jpg",
        "Screwdrivers.jpeg",
        "Spanner wrench kit.jpg",
        "Spanner wrench.jpg",
        "Tool Set.jpg",
        "Tools set big.jpeg",
        "Tools set.jpeg",
        "Wire Cutter BIg.jpeg",
        "Wire cutter small.jpeg",
        "Wrench.jpg"
    ]
};
